import { get, post } from './requests'

// keys stay as the api has them (salesforce_integration_partner, destination_ids)
const CONFIG = { transformPayload: false }

// destinations whose name or slug contains the search, ignoring case
export const getMatchingDestinations = (id, q) =>
  get(['salesforce-integration-partners', id, 'matching-destinations'], CONFIG, { q })

export const assignDestinations = (id, destination_ids) =>
  post(['salesforce-integration-partners', id, 'assign'], CONFIG, { destination_ids })
